/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { usePermission } from '@efexteam/permission-manager';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';
import LogoController from '@/layout/login/components/LogoController/LogoController';
import { isLegacyAuth } from '@/services/auth/authUtils';
import FEATURES_APP from '../../configs/featureflags';
import useMediaQuery from '../../hooks/useMediaQuery';
import { selectProfileData } from '../../pages/profile/store/selectors';
import { toggleSidebar } from '../../pages/store/ui';
import { selectSidebarState } from '../../pages/store/ui/selectors';
import FloatSubmenu from './components/FloatSubmenu/FloatSubmenu';
import Referrer from './components/Referral';
import { AppSection, sidebarUserNav } from './config';

const Sidebar = () => {
  const { t } = useTranslation();
  const { whiteLabelState } = useWhiteLabelService();
  const { can } = usePermission();

  const dispatch = useDispatch();
  const userProfile = useSelector(selectProfileData);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const sidebarState = useSelector(selectSidebarState);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const matches = useMediaQuery('(min-width: 1024px)');

  const navText: Record<AppSection, string> = {
    dashboard: 'Dashboard',
    receivables: t('receivables'),
    payables: t('payables'),
    clients: t('contacts'),
    balances: t('deposits'),
    security: t('security'),
    savings: t('svngsPageTitle'),
  };

  const sidebarNav = sidebarUserNav(can).filter(
    (item) => item.section !== 'security' || isLegacyAuth()
  );

  useEffect(() => {
    const curPath = window.location.pathname.split('/')[1];
    const activeItem = sidebarNav.findIndex(
      (item: any) => item.section === curPath
    );

    setActiveIndex(curPath.length === 0 ? 0 : activeItem);
  }, [location, sidebarNav]);

  useEffect(() => {
    if (sidebarRef.current) {
      // eslint-disable-next-line no-nested-ternary
      sidebarRef.current.style.left = matches
        ? 'inherit'
        : sidebarState.open
        ? '0'
        : '-100%';
    }
  }, [sidebarState, matches]);

  return (
    <>
      <Box
        className={`fixed inset-0 bg-black/40 transition-opacity duration-500 ${
          sidebarState.open ? 'opacity-100 visible' : 'opacity-0 invisible'
        } z-[100]`}
        onClick={() => !matches && dispatch(toggleSidebar())}
      />
      <Box
        className="flex flex-col text-[#4e4d4f] w-[280px] bg-white h-screen fixed top-0 transition-all duration-300 ease-in-out border-r border-[#c7c7c7] lg:left-auto md:z-[101] md:left-[-100%] z-[101]"
        ref={sidebarRef}
      >
        <Box className="flex items-center justify-center border-b border-[#c7c7c7] h-[100px] mb-6 md:h-20">
          <Link to="/">
            <LogoController
              isWhiteLabel={!!whiteLabelState.organizationID}
              efexLogoProps={{ className: 'max-w-[80%]' }}
              whiteLabelLogo={whiteLabelState.organizationLogoURL}
            />
          </Link>
        </Box>
        <Box className="flex flex-col flex-grow overflow-auto">
          {sidebarNav.map((navItem, index: number) => (
            <Link
              onClick={() => !matches && dispatch(toggleSidebar())}
              to={navItem.link}
              key={navItem.link}
              className={`flex items-center justify-start relative py-2.5 pl-[10%] transition-colors duration-300 text-[0.9rem] hover:text-primary md:pl-6 ${
                activeIndex === index ? 'font-bold bg-[#ebf3fa]' : ''
              } ${navItem.section === 'clients' ? 'fifth-step' : ''}`}
              onMouseOver={(e) => setAnchorEl(e.currentTarget)}
              onMouseLeave={() => setAnchorEl(null)}
            >
              <Box className="w-10 h-10 mr-3.5 flex items-center justify-center md:mr-4">
                {typeof navItem.icon === 'string' ? (
                  <img
                    src={navItem.icon}
                    alt="icon-navItem"
                    className={`w-5 h-5 ${
                      activeIndex === index
                        ? ''
                        : 'filter brightness-200 invert-0 opacity-50'
                    }`}
                  />
                ) : (
                  <Box
                    className={`w-5 h-5 ${
                      activeIndex === index
                        ? ''
                        : 'filter brightness-200 invert-0 opacity-50'
                    }`}
                  >
                    {navItem.icon}
                  </Box>
                )}
              </Box>
              <Box className="text-sm">{navText[navItem.section]}</Box>
              {navItem.subLinks && navItem.section !== 'balances' ? (
                <FloatSubmenu
                  anchorEl={anchorEl}
                  subLinks={navItem.subLinks}
                  navItemRef={navItem.link}
                  title={navItem.title}
                />
              ) : null}
              {navItem.subLinks && navItem.section === 'balances' ? (
                <FloatSubmenu
                  anchorEl={anchorEl}
                  subLinks={navItem.subLinks}
                  navItemRef={navItem.link}
                  title={navItem.title}
                />
              ) : null}
            </Link>
          ))}
          {userProfile?.isFullRegister && FEATURES_APP.accountStatus && (
            <Referrer />
          )}
        </Box>
      </Box>
    </>
  );
};

export default Sidebar;
